// Delivery date calculation utility

export const calculateDefaultDeliveryDate = () => {
  const now = new Date();
  const currentHour = now.getHours();
  const cutoffHour = 11; // 11:00 AM cutoff
  
  let deliveryDate = new Date(now);
  
  if (currentHour < cutoffHour) {
    // Before 11 AM - same day delivery
    // deliveryDate stays as today
  } else {
    // After 11 AM - next day delivery
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    
    // If next day is Sunday (0), move to Monday
    if (deliveryDate.getDay() === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
  }
  
  return deliveryDate;
};

export const getMinDeliveryDate = () => {
  const now = new Date();
  const currentHour = now.getHours();
  const cutoffHour = 11;
  
  let minDate = new Date(now);
  
  if (currentHour >= cutoffHour) {
    // After 11 AM - minimum is tomorrow
    minDate.setDate(minDate.getDate() + 1);
    
    // If tomorrow is Sunday, minimum is Monday
    if (minDate.getDay() === 0) {
      minDate.setDate(minDate.getDate() + 1);
    }
  }
  
  return minDate;
};

export const formatDeliveryDate = (date) => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-IN', options);
};

export const formatDateForInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const isDateDisabled = (dateString) => {
  const date = new Date(dateString);
  const minDate = getMinDeliveryDate();
  
  // Reset time for comparison
  date.setHours(0, 0, 0, 0);
  minDate.setHours(0, 0, 0, 0);
  
  // Disable Sundays
  if (date.getDay() === 0) return true;
  
  // Disable dates before minimum delivery date
  if (date < minDate) return true;
  
  return false;
};

export const getDeliveryMessage = () => {
  const now = new Date();
  const currentHour = now.getHours();
  const cutoffHour = 11;
  
  if (currentHour < cutoffHour) {
    return {
      type: 'same-day',
      message: `Order before 11:00 AM for same-day delivery/pickup`,
      timeRemaining: `${cutoffHour - currentHour} hour${cutoffHour - currentHour > 1 ? 's' : ''} remaining`
    };
  } else {
    const defaultDate = calculateDefaultDeliveryDate();
    return {
      type: 'next-day',
      message: `Orders after 11:00 AM will be ready on ${formatDeliveryDate(defaultDate)}`,
      timeRemaining: null
    };
  }
};

export const DELIVERY_TIME_SLOT = '4:00 PM - 6:00 PM';

// Gift hampers take 3 days from order placement (skip Sundays)
export const calculateHamperDeliveryDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 3);
  if (date.getDay() === 0) date.setDate(date.getDate() + 1); // skip Sunday
  return date;
};
